import _ from 'lodash';
import createWorker from './createWorker';

class ImportWorker {
  #worker = null;

  #dataComposers = {
    prepareTasksForMppImport: data => {
      return data;
    },

    prepareTasksForXLSXImport: data => {
      return data;
    },
  };

  constructor() {
    this.#initWorker();
  }

  #initWorker() {
    let version = Date.now();

    if (GT.productVersion && GT.productVersion.buildVersion) {
      version = GT.productVersion.buildVersion;
    }

    this.#worker = createWorker(`/workers/import_worker.js?${version}`);
  }

  async calculate(data, composer, action) {
    const updatedData = this.#dataComposers[composer](data);

    if (!updatedData) {
      return Promise.resolve(false);
    }

    const calculatedData = await this.#worker(_.cloneDeep({
      updatedData,
      action: action || composer,
    }));

    return Promise.resolve(calculatedData);
  }
}

export default new ImportWorker();
